export default "__VITE_ASSET__egKbPJUd__"